<template>
  <div class="vp-failure">
    <div class="vp-failure__result-card">
      <div class="vp-failure__result-inner">
        <div class="vp-failure__result-title">核验失败 · 无有效收据数据</div>
        <div class="vp-failure__result-text">
          您所核验的收据核验码无效、已被篡改或不存在
        </div>
        <div class="vp-failure__result-text">
          本平台未查询到该核验码对应的任何收据信息
        </div>
        <div class="vp-failure__result-text">
          请核实核验码正确性，或联系出票方确认收据真实性
        </div>
      </div>
    </div>

    <div class="vp-failure__card">
      <div class="vp-failure__head">
        <span class="vp-failure__icon">!</span>
        <span class="vp-failure__title">核验失败提示</span>
      </div>
      <ul class="vp-failure__list">
        <li>1. 该收据核验码(89757-202602-10276143)无效或已被篡改,<span class="vp-failure__highlight">本收据不具备任何法律效力</span>；</li>
        <li>2. 如您对核验结果有异议,请联系出票方核实,或拨打官方客服热线:400-XXXX-XXXX；</li>
        <li>3. 警惕虚假收据诈骗,任何基于无效收据的资金往来均不受法律保护。</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FailureView',
};
</script>

<style lang="scss" scoped>
.vp-failure {
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  max-width: 1200px;
  margin-top: 20px;
}

.vp-failure {
  .vp-failure__result-card {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    padding: 18px;
    box-sizing: border-box;
  }

  .vp-failure__result-inner {
    min-height: 300px;
    border: 1px solid #a0522d;
    background: #fdf1e3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 36px 16px;
    text-align: center;
    box-sizing: border-box;
  }

  .vp-failure__result-title {
    font-size: 28px;
    font-weight: 700;
    color: #e43d41;
    margin-bottom: 18px;
    line-height: 1.2;
  }

  .vp-failure__result-text {
    font-size: 14px;
    color: #7b5a3a;
    line-height: 2;
  }

  .vp-failure__card {
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    padding: 24px 28px 24px 24px;
    padding-left: 28px;
    border-left: 4px solid #e43d41;
    box-sizing: border-box;
    text-align: left;
    margin-top: 16px;
  }

  .vp-failure__head {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .vp-failure__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #e43d41;
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .vp-failure__title {
    font-size: 17px;
    font-weight: 700;
    color: #e43d41;
    line-height: 1.3;
  }

  .vp-failure__list {
    margin: 0 0 20px 0;
    font-size: 14px;
    line-height: 1.7;
    color: #333333;
    word-wrap: break-word;
    white-space: normal;

    li {
      margin-bottom: 3px;
    }

    li:last-child {
      margin-bottom: 0;
    }
  }

  .vp-failure__highlight {
    color: #e43d41;
    font-weight: 600;
  }
}

@media (max-width: 768px) {
  .vp-failure {
    .vp-failure__card {
      padding: 18px 16px 20px 20px;
      border-left-width: 4px;
    }

    .vp-failure__result-card {
      padding: 12px;
    }

    .vp-failure__result-inner {
      min-height: 240px;
      padding: 24px 12px;
    }

    .vp-failure__result-title {
      font-size: 22px;
      margin-bottom: 14px;
    }

    .vp-failure__head {
      margin-bottom: 16px;
    }

    .vp-failure__title {
      font-size: 16px;
    }

    .vp-failure__list {
      font-size: 13px;
      line-height: 1.65;
      margin-bottom: 18px;
    }
  }
}
</style>
